
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.146 15.832a2.431 2.431 0 00-2.083 1.179c-3.625-.209-6.825 2.658-7.713 3.533l-.587-.586c4.018-3.86 7.088-6.533 8.052-7.362a2.429 2.429 0 10-1.2-2.093c0 .076 0 .151.011.225-1.913 1.22-7.311 6.592-8.407 7.689l-.533-.533c5.939-6.037 7.274-10.547 7.571-12.1a2.433 2.433 0 10-2.168-.5c-1.5 5.447-5.914 9.959-7 11.009l-.548-.548c2.451-3.252 2.543-5.937 2.467-6.954a2.43 2.43 0 10-2.32.007 9.121 9.121 0 01-1.8 5.292L8.83 13.032a1.474 1.474 0 00-2.085 0 1.126 1.126 0 00-.074.081l-4.234 4.234a1.475 1.475 0 002.085 2.085l3.269-3.269 7.057 7.056-3.269 3.27a1.475 1.475 0 002.085 2.085l4.312-4.312a1.474 1.474 0 000-2.085l-.082-.082c3.006-2.36 5.126-2.805 6.018-2.878a2.43 2.43 0 102.234-3.385zm-1.1-6.838a1.51 1.51 0 11-1.51 1.51 1.511 1.511 0 011.514-1.507zM20.665 1.92a1.51 1.51 0 11-1.51 1.51 1.511 1.511 0 011.51-1.51zm-9.33 4.737a1.51 1.51 0 111.51 1.51 1.511 1.511 0 01-1.51-1.51zm14.811 13.118a1.51 1.51 0 111.51-1.51 1.511 1.511 0 01-1.51 1.51z","fill":"#222"}})])
          )
        }
      }
    